import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';
import { GeneralPatientInfoSkeleton } from '../../../../shared/general-patient-info/general-patient-info.skeleton';
import { LabeledTextSkeleton } from '../../../../shared/labeled-text/labeled-text.skeleton';
import { IvStatusSkeleton } from './iv-status/iv-status.skeleton';

export const PatientDetailsSectionSkeleton: FC = () => {
  return (
    <>
      <GeneralPatientInfoSkeleton />
      <Box sx={{ margin: '0 25px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <LabeledTextSkeleton labelWidth={30} textWidth={100} sx={{ marginRight: '50px' }} />
          <LabeledTextSkeleton labelWidth={40} textWidth={50} />
        </Box>
        <Box sx={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>
          <Skeleton variant="text" sx={{ height: '15px', width: '55px' }} />
          <Skeleton variant="text" sx={{ height: '18px', width: '220px' }} />
          <Skeleton variant="text" sx={{ height: '18px', width: '160px' }} />
        </Box>
        <Box sx={{ marginTop: '10px', display: 'flex', flexDirection: 'column' }}>
          <Skeleton variant="text" sx={{ height: '15px', width: '65px' }} />
          <IvStatusSkeleton />
        </Box>
      </Box>
    </>
  );
};
